/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleMappingExistsGetRoleMappingsIdExists200Response
 */
export interface RoleMappingExistsGetRoleMappingsIdExists200Response {
    /**
     * 
     * @type {boolean}
     * @memberof RoleMappingExistsGetRoleMappingsIdExists200Response
     */
    _exists?: boolean;
}

/**
 * Check if a given object implements the RoleMappingExistsGetRoleMappingsIdExists200Response interface.
 */
export function instanceOfRoleMappingExistsGetRoleMappingsIdExists200Response(value: object): value is RoleMappingExistsGetRoleMappingsIdExists200Response {
    return true;
}

export function RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(json: any): RoleMappingExistsGetRoleMappingsIdExists200Response {
    return RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSONTyped(json, false);
}

export function RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleMappingExistsGetRoleMappingsIdExists200Response {
    if (json == null) {
        return json;
    }
    return {
        
        '_exists': json['exists'] == null ? undefined : json['exists'],
    };
}

export function RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON(json: any): RoleMappingExistsGetRoleMappingsIdExists200Response {
    return RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSONTyped(json, false);
}

export function RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSONTyped(value?: RoleMappingExistsGetRoleMappingsIdExists200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exists': value['_exists'],
    };
}

